<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailLetter" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Alamat Supplier</div>
									<v-checkbox v-model="supplierAddress" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Produk</div>
									<v-checkbox v-model="productSummary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Jadwal Pengiriman</div>
									<v-checkbox v-model="scheduleSumary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn text large depressed class="primary col-12 mt-5" @click="printDiv(detailPO.po_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="deep-purple lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="7" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="5" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1 text-uppercase">Pemesanan</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<div class="pb-3" v-if="detailLetter">
										<div class="border-topbot-dotted py-3 mt-3">
											<v-row>
												<v-col cols="6" class="pb-0">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2 font-weight-bold">Nomor</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2 font-weight-bold">{{ detailPO.po_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="6">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Atas nama</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailPO.po_status_created_user_name }}</span>
														</v-col>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Tanggal</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailPO.po_status_created_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="6">
													<v-row>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Supplier</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailPO.supplier_name }}</span>
														</v-col>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Telephone</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailPO.supplier_mobilephone }}</span>
														</v-col>
														<v-col cols="4" class="py-0">
															<div class="text-body-2">Email</div>
														</v-col>
														<v-col cols="8" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailPO.supplier_email }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="supplierAddress">
										<v-card outlined class="mt-3">
											<v-row class="py-3">
												<v-col cols="6" class="py-0">
													<div class="pl-4 text-body-2 font-weight-bold">Alamat Supplier</div>
													<div class="pl-4 pt-2 text-body-2">{{ addresText }}</div>
												</v-col>
												<v-col cols="6" class="py-0 border-left-grey">
													<div v-if="detailPO.po_status == 'supp_rejected'">
														<div class="pl-4 pt-2 text-body-2">
															<span>Tanggal Pembatalan</span>
															<span class="pl-4">: {{ detailPO.po_status_supp_rejected_datetime | tanggal }}</span>
														</div>
													</div>
													<div v-else>
														<v-row>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Approve</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailPO.po_status_supp_approved_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pl-4 pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Proses</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailPO.po_status_supp_processed_datetime | tanggal }}</span>
																</div>
															</v-col>
														</v-row>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="pb-3" v-if="productSummary">
										<v-card class="mt-3" outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Jumlah</th>
															<th class="text-center">Berat</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailPO.po_detail" :key="product.po_detail_id">
															<td class="text-left">{{ product.po_detail_product_name }}</td>
															<td class="text-center">
																<div v-if="detailPO.po_status == 'created' || detailPO.po_status == 'wh_rejected'">
																	{{ product.po_detail_quantity_requested }} {{product.po_detail_product_unit}}
																</div>
																<div v-else>{{ product.po_detail_quantity_approved }} {{product.po_detail_product_unit}}</div>
															</td>
															<td class="text-center">{{ product.po_detail_product_weight | toKg }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="pb-3 mt-2" v-if="scheduleSumary">
										<div class="text-center black--text text-subtitle-1 font-weight-bold">Jadwal Pengiriman</div>
										<v-card class="mt-3" outlined v-for="(data, index) in poSchedules" :key="index">
											<span class="text-body-2 font-weight-bold">{{index | haritanggal}}</span>
											<v-simple-table class="white-row mt-2">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Kode Produk</th>
															<th class="text-center">Jumlah</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in data" :key="product.po_detail_id">
															<td class="text-left">{{ product.product_name }}</td>
															<td class="text-center">
																<div>{{ product.product_code }}</div>
															</td>
															<td class="text-center">{{ product.po_schedule_detail_quantity | toNumber }} {{ product.product_unit }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-3" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div class="pt-2 text-body-2">
											<div v-if="detailPO.po_note">{{ detailPO.po_note }}</div>
											<div v-else>Tidak ada catatan</div>
										</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			detailLetter: true,
			supplierAddress: true,
			productSummary: true,
			scheduleSumary: true,
			note : true,
		}
	},
	computed: {
		...mapState('po', ['detailPO']),
		...mapState('common', ['letterHeader']),

		addresText() {
			var data = []
			if (this.detailPO) {
				if (this.detailPO.supplier_address)
					data.push(this.detailPO.supplier_address)
				if (this.detailPO.supplier_subdistrict_name)
					data.push(this.detailPO.supplier_subdistrict_name)
				if (this.detailPO.supplier_city_name)
					data.push(this.detailPO.supplier_city_name)
				if (this.detailPO.supplier_province_name)
					data.push(this.detailPO.supplier_province_name)
			}
			return data.join(', ')
		},
		grandTotal(){
			let total = 0
			if (this.detailPO.po_detail) {
				if (this.detailPO.po_status == 'supp_approved' || this.detailPO.po_status == 'supp_processed') {
					this.detailPO.po_detail.forEach( (el) => {
						total += el.po_detail_product_price * el.po_detail_quantity_approved
					});
				} else {
					this.detailPO.po_detail.forEach( (el) => {
						total += el.po_detail_product_price * el.po_detail_quantity_requested
					});
				}
			}
			return total
		},
		poSchedules() {
			let schedule = []
			if (this.detailPO.po_schedules) {
				schedule = this.detailPO.po_schedules.reduce((r, a) => {
					r[a.po_schedule_detail_date] = [...r[a.po_schedule_detail_date] || [], a];
					return r;
				}, {});
			}
			return schedule
		},
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		},
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.detailLetter = true
				this.supplierAddress = true
				this.productSummary = true
				this.scheduleSumary = true
				this.note  = true
			}
		}
	},
};
</script>